<template>
  <b-modal
    :id="'product-movement-modal'"
    hide-header
    hide-footer
    centered
    size="xl"
    @show="onShow"
    @hidden="closeModal"
    modal-class="modal-custom"
    no-close-on-backdrop
  >
    <div class="modal-header">
      <div class="modal-title">
        <span>Movimentação de produto</span>
      </div>
      <span class="icon-close">
        <Close class="stroke" @click="closeModal" />
      </span>
    </div>

    <div class="around-content">
      <b-row class="px-2">
        <b-col class="mt-3" cols="2">
          <b-form-group>
            <label for="request_date">Data</label>
            <date-picker
              placeholder="Selecionar"
              v-model="localRequest.request_date"
              name="request_date"
              format="DD/MM/YYYY"
              value-type="date"
              id="request_date"
              :lang="langDatePicker"
              :clearable="false"
              class="full"
              :state="errors?.request_date ? false : null"
              ref="request_date"
              :disabled="true"
            />
            <b-form-invalid-feedback
              :state="errors.request_date ? false : null"
            >
              {{ errors.request_date }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" cols="5">
          <b-form-group>
            <label for="person_id	">Solicitante</label>
            <multiselect
              id="person_id	"
              autocomplete="off"
              v-model="selectedResponsible"
              :options="[]"
              track-by="id"
              label="label"
              :option-height="40"
              :showLabels="false"
              :searchable="true"
              placeholder="Selecione um tipo"
              class="with-border"
              ref="person_id	"
              :disabled="true"
            >
              <template slot="caret">
                <div class="chevron">
                  <ChevronDown />
                </div>
              </template>
              <template slot="noOptions"> Nenhuma opção </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
            <div
              v-if="errors.local_stock_sector_id ? true : false"
              class="custom-invalid-feedback"
            >
              Campo obrigatório
            </div>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" cols="5">
          <b-form-group>
            <label for="local_stock_sector_id">Destino Final</label>
            <multiselect
              id="local_stock_sector_id"
              autocomplete="off"
              v-model="selectedStockLocation"
              :options="[]"
              track-by="id"
              label="label"
              :option-height="40"
              :showLabels="false"
              :searchable="true"
              placeholder="Selecione um tipo"
              class="with-border"
              :state="errors?.local_stock_sector_id ? false : null"
              ref="local_stock_sector_id"
              :disabled="true"
            >
              <template slot="caret">
                <div class="chevron">
                  <ChevronDown />
                </div>
              </template>
              <template slot="noOptions"> Nenhuma opção </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
            <div
              v-if="errors.local_stock_sector_id ? true : false"
              class="custom-invalid-feedback"
            >
              Campo obrigatório
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />

      <div id="request" class="card" v-if="localRequest.product_requests">
        <div class="card-header">Solicitação</div>
        <div class="card-body p-2" v-for="(productRequest, index) in localRequest.product_requests" :key="index">
          <b-row>
            <b-col cols="7" class="align-content-center">
              <div class="txt-product-status">
                <div class="priority-icon">
                  <component :is="getPriority(productRequest.priority_code)" />
                </div>
                <strong class="p-2 txt-product">{{
                  productRequest?.product?.name
                }}</strong>
              </div>
            </b-col>
            <b-col cols="5" v-if="productRequest.status === 'pendente'">
              <p class="h-100 alert request-status" :class="{
                'alert-success': productRequest.pending <= 0,
                'alert-danger': productRequest.pending > 0
              }">
                Pedido: {{ productRequest.quantity }} {{ productRequest.unit?.short_name }} | Estoque: {{ productRequest.balance }} {{ productRequest.unit?.short_name }}
                <span v-if="productRequest.pending > 0">
                  | Faltam: {{ productRequest.pending }} {{ productRequest.unit?.short_name }}
                </span>
              </p>
            </b-col>
          </b-row>

          <b-row
            class="px-2"
            v-for="(item, batchIndex) in productRequest?.batches"
            :key="batchIndex"
          >
            <b-col cols="3" class="mt-3">
              <b-form-group>
                <label for="batch_balance_id">Lote</label>
                <multiselect
                  id="batch_balance_id"
                  autocomplete="off"
                  v-model="productRequest.batch_balance"
                  :options="batches"
                  track-by="id"
                  label="label"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  placeholder="Selecione"
                  class="with-border"
                  @open="getBatches(productRequest.product_id)"
                  @select="changeSelectedBatch(index, batchIndex, $event)"
                  :state="errors?.kit_template_id ? false : null"
                  ref="batch_balance_id"
                >
                  <template slot="caret">
                    <div class="chevron">
                      <ChevronDown />
                    </div>
                  </template>
                  <template slot="noOptions"> Nenhuma opção </template>
                  <template slot="noResult"> Nenhum resultado </template>
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" cols="3">
              <b-form-group>
                <label for="local_stock_sector_id">Setor / Origem</label>
                <multiselect
                    id="local_stock_sector_id"
                    autocomplete="off"
                    v-model="productRequest.local_stock_sectors"
                    :options="[]"
                    track-by="id"
                    label="label"
                    :option-height="40"
                    :showLabels="false"
                    :searchable="true"
                    placeholder="Selecionar"
                    class="with-border"
                    ref="local_stock_sector_id"
                >
                  <template slot="caret">
                    <div class="chevron">
                      <ChevronDown />
                    </div>
                  </template>
                  <template slot="noOptions"> Nenhuma opção </template>
                  <template slot="noResult"> Nenhum resultado </template>
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" cols="1">
              <b-form-group>
                <label for="quantity">Qtde.</label>
                <b-form-input
                  v-model="item.quantity"
                  placeholder="00"
                  autocomplete="off"
                  type="number"
                  min="1"
                  :state="errors?.quantity ? false : null"
                  ref="quantity"
                />
                <b-form-invalid-feedback v-if="errors?.quantity">
                  {{ errors.quantity }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" cols="2">
              <b-form-group>
                <label for="unit_id">Unid.</label>
                <multiselect
                  id="unit_id"
                  autocomplete="off"
                  v-model="item.unit"
                  :options="unitOptions"
                  track-by="id"
                  label="name"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  placeholder=""
                  class="with-border"
                  :state="errors?.unit_id ? false : null"
                  ref="unit_id"
                >
                  <template slot="caret">
                    <div class="chevron">
                      <ChevronDown />
                    </div>
                  </template>
                  <template slot="noOptions"> Nenhuma opção </template>
                  <template slot="noResult"> Nenhum resultado </template>
                </multiselect>
                <div
                  v-if="errors.unit_id ? true : false"
                  class="custom-invalid-feedback"
                >
                  Campo obrigatório
                </div>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" cols="3">
              <div class="d-flex">
                <b-form-group>
                  <label for="type_use_code">Tipo de uso</label>
                  <b-form-input
                    ref="type_use_code"
                    autocomplete="off"
                    id="type_use_code"
                    trim
                    placeholder=""
                    v-model="productRequest.type_use.label"
                    :disabled="true"
                  />
                </b-form-group>
              
                <div
                  class="btn-group btn-group-sm align-items-end"
                  role="group"
                  aria-label="Basic example"
                >
                  <button type="button" class="btn mb-2">
                    <Icon>
                      <span
                        class="badge badge-pill badge-info position-absolute ml-3"
                        >{{ productRequest.comments?.length }}</span
                      >
                      <Comment
                        class="icon icon-comment"
                        @click="openModalComment(index)"
                      />
                    </Icon>
                  </button>
                  <button type="button" class="btn mb-2">
                    <Icon>
                      <Trash
                        class="icon icon-trash"
                        @click="deleteBatchRequest(index)"
                      />
                    </Icon>
                  </button>
                </div>
              </div>
              
            </b-col>
          </b-row>

          <b-row class="px-2">
            <b-col class="mt-3 text-center" cols="12">
              <a
                href="#"
                class="card-link"
                v-if="productRequest.status === 'pendente'"
                @click="addBatchRequest(index)"
                >Adicionar novo lote</a
              >
            </b-col>
          </b-row>

          <b-row v-if="productRequest.status === 'pendente' && productRequest.pending > 0 && productRequest.balance <= 0" class="m-3">
            <b-col cols="12">
              <p class="alert alert-secondary">Não há itens suficientes. Avise o solicitante que o produto está será entregue parcialmente clicando em ”Efetuar movimentação".</p>
            </b-col>
          </b-row>

          <hr v-if="index !== localRequest.product_requests?.length - 1">

        </div>
      </div>
    </div>

    <div class="wrapper-button text-right mt-5">
      <b-button
        variant="link"
        class="link-disapprove"
        @click="disapproveRequest"
        v-if="localRequest.product_requests?.find(item => item.status === 'pendente')"
      >
        Reprovar a solicitação
      </b-button>
      <b-button
        variant="primary"
        size="lg"
        @click="saveForm"
        :disabled="localRequest.status !== 'pendente'"
      >
        Efetuar movimentação
      </b-button>
    </div>

    <CommentRequestModal
      ref="commentModal"
      :product="selectedProduct"
      @update-product-request-comment="updateProductRequestComment"
    />

    <ConfirmMovementModal :productRequest="localRequest.product_requests" />
  </b-modal>
</template>

<script>
import '@/assets/scss/modal-custom.scss'
import '@/assets/scss/table.scss'
import api from '@/modules/warehouse/api'

import moment from 'moment'
import { getCurrentClinic, getCurrentUser } from '@/utils/localStorageManager'
import CommentRequestModal from './CommentRequestModal.vue'
import ConfirmMovementModal from './ConfirmMovementModal.vue'

export default {
  components: {
    CommentRequestModal,
    ConfirmMovementModal,
    AutocompleteBatch: () => import('@/components/Warehouse/Autocomplete.vue'),
    Icon: () => import('@/components/General/Icon'),
    Trash: () => import('@/assets/icons/trash.svg'),
    Close: () => import('@/assets/icons/close.svg'),
    Comment: () => import('@/assets/icons/comment.svg'),
    ChevronDown: () => import('@/assets/icons/chevron-down-select.svg'),
    'Plus': () => import('@/assets/icons/plus.svg'),
    Priority4: () => import('@/assets/icons/flag-red.svg'),
    Priority3: () => import('@/assets/icons/flag-yellow.svg'),
    Priority2: () => import('@/assets/icons/flag-green.svg'),
    Priority1: () => import('@/assets/icons/flag-blue.svg'),
    Priority0: () => import('@/assets/icons/flag-transparent.svg'),
  },
  data() {
    return {
      clinic: getCurrentClinic(),
      user: getCurrentUser(),
      localRequest: {},
      selectedStockLocation: null,
      selectedTypeUse: null,
      selectedResponsible: null,
      selectedBatch: null,
      batches: [],
      typeUseOptions: [
        { label: 'Consumo', value: 'CONSUMPTION' },
        { label: 'Venda', value: 'SALE' },
        { label: 'Descarte', value: 'DISCARD' },
        { label: 'Empréstimo (Devolução)', value: 'LOAN' },
        { label: 'Movimentação', value: 'TRANSACTION' },
        { label: 'Cortesia (Amostra Grátis)', value: 'COURTESY' }
      ],
      priorityOptions: [
        {
          code: '0',
          label: ''
        },
        {
          code: '1',
          label: ''
        },
        {
          code: '2',
          label: ''
        },
        {
          code: '3',
          label: ''
        },
        {
          code: '4',
          label: ''
        }
      ],
      batchColors: [
        { color: '#F63220'},
        { color: '#FFC733'},
        { color: '#008C59'}, // verde   
        { color: '#294EEC'}, // azul
      ],
      unitOptions: [],
      stockLocationOptions: [],
      selectedProduct: {},
      errors: {},
      langDatePicker: {
        formatLocale: {
          months: moment.months(),
          monthsShort: moment.monthsShort()
        }
      }
    }
  },
  props: {
    request: {
      type: Object,
      default: () => ({})
    },
    refresh: Function
  },
  async mounted() {
    
  },
  methods: {
    // --------- Métodos de tabelas auxiliares  ---------
    getProducts(query) {
      this.api
        .getProducts(this.clinic.id, 1, query)
        .then(res => {
          this.productOptions = res.data.data.map(item => ({
            ...item
          }))
        })
        .catch(err => this.$toast.error(err.message))
    },
    getBatchColor(lote) {
      const currentYear = this.moment().year();
      const expirationYear = this.moment(lote.date).year();
      const diffYears = expirationYear - currentYear;

      let index;

      switch (true) {
        case (diffYears <= 0):
          index = 0;
          break;
        case (diffYears === 1):
          index = 1;
          break;
        case (diffYears === 2):
          index = 3;
          break;
        default:
          index = 2;
      }

      return this.batchColors[index].color;
    },
    async getBatches (productId) {
      try {
        const { data } = await this.api.getProductBatches(productId, { hasBalance: true })

        const options = data.map(batch => ({
          id: batch?.id,
          balance: batch.balance,
          date: new Date(batch.expiration_date),        
          expiration_date: new Date(batch.expiration_date),        
          manufacturing_date: new Date(batch.manufacturing_date),        
          label: batch?.batch,
          local_stock_sectors: batch.local_stock_sectors		
        }));
        
        this.batches = options;

      } catch (error) {
        this.$toast.error('Não foi possível encontrar o lote, contato o suporte se o erro persistir.')
      }
    },
    // --------- Métodos de Gerenciamento do Formulário ---------
    resetForm() {
      this.form = {}
      this.errors = {}
    },
    isValidForm() {
      const errors = {}

      if (this.localRequest.status !== 'pendente') {
        this.$toast.error('Solicitação nao pode ser editada.')
        return
      }

      if (
        this.localRequest.batches.find(
          el => !el.batch || !el.quantity || !el.stock || !el.unit
        )
      ) {
        this.$toast.warning(
          'É obrigatório preencher os dados de baixa do lote. Para efetuar a movimentação, é necessário ' +
            'selecionar pelo menos um lote e preencher todos os dados exigidos (quantidade, unidade, ' +
            'lote e local de estoque).'
        )
        return
      }

      this.errors = errors

      return Object.keys(errors).length === 0
    },
    async saveForm() {
      if (!this.isValidForm()) {
        this.$toast.error('Preencha todos os campos obrigatórios.')
        return
      }

      this.$bvModal.show('confirm-movement-modal')


      // this.closeModal();
    },
    // --------- Métodos de Controle do Modal ---------
    openModal(origin) {
      this.origin = origin
      this.$bvModal.show('product-movement-modal')
    },
    onShow() {
      this.resetForm()
    },
    closeModal() {
      this.form = {}
      this.batches = []
      this.$bvModal.hide('product-movement-modal')
    },
    // --------- Métodos de Produtos ---------
    getPriority(priority) {
      return 'Priority' + priority
    },
    // --------- Métodos de gerenciamento de observações  ---------
    openModalComment(index) {
      this.selectedProduct = this.localRequest.product_requests[index];
      this.selectedProduct.index = index;
      this.$bvModal.show('comment-request-modal')
    },
    async updateProductRequestComment(item) {
      this.selectedProduct.comments = item.comments
      await api.createProductStockComment({
        product_stock_request_id: item.id,
        ...this.selectedProduct.comments[this.selectedProduct.comments.length - 1]
      })
    },
    // --------- Métodos manter Solicitação  ---------
    async disapproveRequest() {
      const { isConfirmed } = await this.$swal.fire({
        icon: 'question',
        html: `<div class="body-alert">Tem certeza que deseja reprovar esta solicitação?<br/><br/>
                    Esta ação não poderá ser desfeita.
                </div>`,
        showCancelButton: true,
        confirmButtonColor: '#F63220',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      })

      if (isConfirmed) {
        await api.disapproveRequest(this.localRequest.id).then(res => {
          this.$toast.success('Solicitação reprovada com sucesso!')
          this.refresh()
          this.closeModal()
        })
        .catch(err => this.$toast.error(err.message))
      }
    },
    addBatchRequest(index) {
      this.localRequest.product_requests[index].batches.push({
        batch_id: null,
        quantity: null
      })
    },
    deleteBatchRequest(index) {
      this.localRequest.batches.splice(index, 1)
    },
    // --------- Métodos de change do selects  ---------
    changeSelectedBatch(index, option) {
      this.localRequest.product_requests[index].batch_id = option.id;
      this.localRequest.product_requests[index].local_stock_sectors = option.local_stock_sectors;
    },
    typeUseFormat(value){
      console.log('--->', value);
      return this.typeUseOptions.find(
        el => el.value === value
      )
    },
    async getBalance(product) {
      try {
        const balance = await this.getBalance(product);
        return balance;
      } catch (error) {
        // 
      }
    }
  },
  watch: {
    request: {
      async handler(request) {
        if(Object.values(request).length){
          const getTypeUse = (typeUseCode) => {
            return this.typeUseOptions.find(el => el.value === typeUseCode);
          };

          const getBatches = (batches) => {
            return batches || [{ quantity: null }];
          };

          const productRequests = request.product_requests?.map(item => {
            const { product, type_use_code, batches } = item;

            return {
              ...item,
              type_use: getTypeUse(type_use_code),
              batches: getBatches(batches),
              balance: product.product_balance?.balance || 0,
              pending: item.quantity - (product.product_balance?.balance || 0),
            };
          });

          this.localRequest = {
            ...request,
            product_requests: productRequests,
            request_date: moment(request?.request_date).toDate(),
          }

          this.selectedStockLocation = request?.sector
            ? {
                label: `${request?.sector?.stock?.name} - ${request?.sector?.name}`,
                id: request?.sector.id
              }
            : null

          this.selectedResponsible = request?.responsible
            ? {
                id: request?.responsible.id,
                label: request?.responsible.name
              }
            : null;
        }
        
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss">
#product-movement-modal {
  .priority-icon {
    background-color: #f4f5fb;
    height: 35px;
    width: 35px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    padding: 5px;

    svg {
      margin: auto;
    }
  }

  .card-header {
    font-weight: 600;
    font-size: 16px;
    color: var(--dark-blue);
    margin-bottom: 4px !important;
  }

  #request {
    .txt-product {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      text-align: left;
      color: var(--surface-brand, #305bf2);
    }

    .txt-product-status {
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      text-align: left;
    }
  }

  .card-link {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
  }

  .link-disapprove {
    color: #f63220;
  }

  .invalid-feedback {
    display: block;
  }

  .item_priority {
    .multiselect__content-wrapper {
      //
    }
  }

  .request-status {
    width: fit-content;
    float: inline-end;
  }
}
</style>